module.exports = function (settingsByBreakpointService) {
    function AnimationsService() {

    }

    AnimationsService.prototype.isAnimationsEnabled = function () {
        return settingsByBreakpointService.getSettingValueByBreakpoint('OneSite', {
            largeFormat: 'LargeFormatAnimationsEnabled',
            mediumFormat: 'MediumFormatAnimationsEnabled',
            smallFormat: 'SmallFormatAnimationsEnabled'
        });
    };

    return new AnimationsService();
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/common/components/animations/animations-service.js
 **/